var baguetteBox = require('baguettebox.js');

baguetteBox.run('.gallery');
